import * as React from "react";
import { Button, Tooltip } from "@material-ui/core";
import CloudUpload from "@material-ui/icons/CloudUpload";

type Props = {
  onClick: () => void;
  disabled: boolean;
  fetchingData: boolean;
};

export default class ManualVerificationUploadDocumentButton extends React.Component<
  Props
> {
  render() {
    const button = (
      <Button
        color="primary"
        variant="contained"
        className="button no-margin"
        onClick={this.props.onClick}
        disabled={this.props.disabled || this.props.fetchingData}
      >
        Upload ID/passport
        <CloudUpload
          style={{
            marginLeft: "10px",
          }}
        />
      </Button>
    );

    if (!this.props.disabled) {
      return button;
    }

    return (
      <Tooltip
        title="The user must have a failed or errored identity verification, or a manual verification request, before an ID or passport can be uploaded."
        placement="bottom-start"
      >
        <span>{button}</span>
      </Tooltip>
    );
  }
}
